__turbopack_context__.v({
  "accordion": "STAccordion-module__kMhsta__accordion",
  "content": "STAccordion-module__kMhsta__content",
  "darkAccordion": "STAccordion-module__kMhsta__darkAccordion",
  "header": "STAccordion-module__kMhsta__header",
  "icon": "STAccordion-module__kMhsta__icon",
  "inner": "STAccordion-module__kMhsta__inner",
  "item": "STAccordion-module__kMhsta__item",
});
